import logoVerticalTextImg from '/public/plenty-logo-with-text-vertical@2x.png';
import logoHorizontalTextImg from '/public/plenty-logo-with-text@2x.png';
import logoImg from '/public/plenty-logo@2x.png';
import Image from 'next/image';

export default function PlentyLogo({
    textPosition,
    width = 40,
}: {
    textPosition?: 'vertical' | 'horizontal';
    width?: number;
}) {
    if (textPosition === 'horizontal') {
        const height = 0.25 * width;
        return (
            <Image
                alt="logo with Plenty name"
                src={logoHorizontalTextImg}
                // OG dims: 1905 x 486
                width={width}
                height={height}
            />
        );
    }

    if (textPosition === 'vertical') {
        const height = 0.82 * width;
        return (
            <Image
                alt="logo with Plenty name"
                src={logoVerticalTextImg}
                // OG dims: 156x128
                width={width}
                height={height}
            />
        );
    }

    const height = (width * 24) / 40;
    return <Image alt="logo" src={logoImg} width={width} height={height} />;
}
